
export function EncodeNodeBase64(string) {
    //Buffer() requires a number, array or string as the first parameter, and an optional encoding type as the second parameter.
    // The default is "utf8". Possible encoding types are "ascii", "utf8", "ucs2", "base64", "binary", and "hex"
    var b = Buffer.from(string);
    // If we don't use toString(), JavaScript assumes we want to convert the object to utf8.
    // We can make it convert to other formats by passing the encoding type to toString().
    var s = b.toString('base64');
    return s
}